import React from 'react';

const withTqPreviewData = (WrapperComponent) => {
  const BlueBookTqPreviewData = (props) => {
    const { itemId, itemsWithLrnRef } = props;
    const length = itemsWithLrnRef?.length;
    const previewData = {
      itemId,
      items: itemsWithLrnRef || [],
      itemsPerPage: length,
      currentPage: 0,
      total: length,
      hasMorePages: false,
      pathname: '/home/preview/item/',
      loadMoreFF: false,
    };
    return <WrapperComponent {...props} previewData={previewData} />;
  };

  return BlueBookTqPreviewData;
};

export default withTqPreviewData;
